<template>
  <div class="my_content">
    <div class="set" @click="$router.push({ path: '/set' })">设置</div>
    <div class="userInfo" >
      <div class="left">
        <img class="img" @click="$router.push({ path: '/account' })" src="../../assets/images/userImg.png" alt="" />
        <div class="info">
          <p class="name" v-if="$cookies.get('access_token')">{{ $cookies.get("uname") }}</p>
          <p class="name" v-else @click="$router.push({ path: '/login' })">点击登录</p>
          <div class="id">
            <p>ID:{{ $cookies.get("uid") || ''}}</p>
            <span>|</span>
            <p>平台币 0</p>
          </div>
        </div>
      </div>
      <van-icon name="arrow" class="right" @click="$router.push({ path: '/account' })"/>
    </div>
    <div class="super">
      <div class="left">
        <img src="../../assets/images/hg.png" alt="" />
        <img src="../../assets/images/cjhy.png" alt="" />
      </div>
      <div class="right">
        <img src="../../assets/images/cktq.png" alt="" />
      </div>
    </div>
    <mybar></mybar>
    <div class="operateBar" v-if="$cookies.get('access_token')">
      <div class="left" @click="select(1)">
        <p>正在玩</p>
        <span :class="{select:selectIndex == '1'}"></span>
      </div>
      <div class="right" @click="select(2)">
        <p>已关注</p>
        <span :class="{select:selectIndex == '2'}"></span>
      </div>
    </div>
    <mygamebar :index="selectIndex"></mygamebar>
  </div>
</template>

<script>
import mybar from "../../components/my/myBar.vue";
import mygamebar from "../../components/my/myGamebar.vue";
export default {
  components: {
    mybar,
    mygamebar,
  },
  data() {
    return {
      selectIndex: '1',
    };
  },
  methods: {
    select(index) {
      this.selectIndex = String(index);
    },
  },
};
</script>

<style lang="less"  scoped>
.my_content {
  margin: 0 5.6vw;
  padding-bottom: 15vw;
  .set {
    height: 10vw;
    line-height: 10vw;
    text-align: right;
    font-size: 3.5vw;
    font-weight: 600;
    color: #000;
  }
  .userInfo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 3vw;
    .left {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .img {
        width: 16vw;
        height: 16vw;
        border-radius: 50%;
        margin-right: 3vw;
      }
      .info {
        text-align: left;
        .name {
          height: 10vw;
          font-size: 5vw;
          font-weight: 600;
        }
        .id {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 3.5vw;
          span {
            margin: 0 1vw;
          }
        }
      }
    }
    .right {
      width: 30vw;
      font-size: 3.5vw;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
  .super {
    width: 100%;
    height: 14.8vw;
    background-image: url("../../assets/images/cjhybj.png");
    background-size: 100% 14.8vw;
    background-repeat: no-repeat;
    margin-top: 3.5vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      margin-left: 3.3333vw;
      :first-child {
        width: 4vw;
        height: 4vw;
        margin-right: 1.5vw;
      }
      :last-child {
        width: 15.2vw;
        height: 3.7333vw;
      }
    }
    .right {
      margin-right: 3.4667vw;
      img {
        width: 13.6vw;
        height: 4.8vw;
      }
    }
  }
  .operateBar {
    height: 10.4vw;
    background: #fff;
    border-radius: 3vw;
    margin-top: 4vw;
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #ff961c;
    font-size: 4vw;
    font-weight: 600;
    div {
      display: flex;
      align-items: center;
      flex-direction: column;
      span {
        display: block;
        width: 7.9667vw;
        height: 0.7967vw;
        background: #fff;
        border-radius: 2vw;
        margin-top: 1vw;
      }
      .select {
        background: #ff961c;
      }
    }
  }
}
</style>